module.exports = __webpack_public_path__ + "img/immagine-sfondo-hdtool.10302739.png";